import { AxiosInstance } from "axios";
import { getBoardApiUrl } from "helpers";
import { ParticipantModel } from "models/ParticipantModel";
import { PatchParticipantModel } from "models/PatchParticipantModel";
import { SiveActionResult } from "models/SiveActionResult";

export class ParticipantsApi {
  constructor(private axios: AxiosInstance) {}

  async getItems() {
    const url = getBoardApiUrl(`participants`);
    const response = await this.axios.get(url);

    return response.data;
  }

  async getItem(participantId: number): Promise<ParticipantModel> {
    if (!participantId) throw new Error("participantId is required");
    const url = getBoardApiUrl(`participants/${participantId}`);
    const response = await this.axios.get<ParticipantModel>(url);

    return response.data;
  }

  async getGrid(filter: string, skip: number, top: number, meetingId: number) {
    const param = {
      params: {
        skip,
        top,
        filter,
      },
    };

    const url = getBoardApiUrl(`participants/grid/${meetingId}`);
    const response = await this.axios.get(url, param);
    return response.data;
  }

  async addToMeeting(patch: PatchParticipantModel): Promise<SiveActionResult> {
    const { meetingId } = patch;
    if (!meetingId) throw new Error("meetingId is required");
    const url = getBoardApiUrl(`participants/meeting/${meetingId}`);
    const response = await this.axios.post<SiveActionResult>(url, patch);
    return response.data;
  }

  async delete(participantId: number) {
    if (!participantId) throw new Error("participantId is required");
    const url = getBoardApiUrl(`participants/${participantId}`);
    const response = await this.axios.delete<SiveActionResult>(url);
    return response.data;
  }

  async update(patch: PatchParticipantModel) {
    const { id: participantId } = patch;
    if (!participantId) throw new Error("participantId is required");
    const url = getBoardApiUrl(`participants/${participantId}`);
    const response = await this.axios.patch<SiveActionResult>(url, patch);
    return response.data;
  }

  async reorder(participantId: number, previousItemId: number) {
    if (participantId <= 0) throw new Error("participantId is required");
    if (previousItemId <= 0) throw new Error("previousItemId is required");
    const url = getBoardApiUrl(`participants/${participantId}/reorder/${previousItemId}`);
    const response = await this.axios.post<SiveActionResult>(url);
    return response.data;
  }
}
